import { Link } from "react-router-dom";

const medicalDevices = [
  {
    name: "Sleep Apnea",
    description:
      "CPAP and sleep apnea devices for effective sleep therapy.",
    path: "/medical-devices/sleep-apnea",
  },
  {
    name: "Diagnostics",
    description:
      "Diagnostic devices for accurate medical testing and monitoring.",
    path: "/medical-devices/diagnostics",
  },
  {
    name: "Endoscopy",
    description:
      "Endoscopy equipment and accessories for medical procedures.",
    path: "/medical-devices/endoscopy",
  },
  {
    name: "Hospital Consumables",
    description:
      "Essential consumables used in hospitals and healthcare facilities.",
    path: "/medical-devices/hospital-consumables",
  },
  {
    name: "Hospital Equipment",
    description:
      "Hospital equipment designed for professional healthcare use.",
    path: "/medical-devices/hospital-equipment",
  },
  {
    name: "Device Accessories",
    description:
      "Accessories and supporting products for medical devices.",
    path: "/medical-devices/device-accessories",
  },
];

const MedicalDevices = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">
        Medical Devices
      </h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {medicalDevices.map((device, index) => (
          <div
            key={index}
            className="bg-white border border-gray-200 rounded-lg p-5 shadow-sm hover:shadow-md transition"
          >
            <h2 className="text-xl font-semibold text-gray-900">
              {device.name}
            </h2>

            <p className="text-gray-600 text-sm mt-3 min-h-[60px]">
              {device.description}
            </p>

            <Link
              to={device.path}
              className="block text-center mt-5 bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700"
            >
              View Product
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MedicalDevices;